import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// products ////////////////////
const productsUrl = "products";

// get all products
export const getAllProductsDataRequest = (values) =>
  client.get(productsUrl, values);

// add product
export const addProductRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  values.category_id && formData.append("category_id", values.category_id);
  values.subcategory_id &&
    formData.append("subcategory_id", values.subcategory_id);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  !values.image.isWeb && formData.append("image", values.image.url);
  values.video.isChanged && formData.append("video", values.video.url);
  return client.post(`admin/${productsUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// edit product
export const editProductRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  values.category_id && formData.append("category_id", values.category_id);
  values.subcategory_id &&
    formData.append("subcategory_id", values.subcategory_id);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  !values.image.isWeb && formData.append("image", values.image.url);
  values.video.isChanged && formData.append("video", values.video.url);
  return client.post(
    `admin/${productsUrl}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

// get product by id
export const getProductByIdRequest = (values) =>
  client.get(`${productsUrl}/${values.id}`);

// delete product by id
export const deleteProductByIdRequest = (id) =>
  client.delete(`admin/${productsUrl}/${id}`);

/////// products category ///////
const productsCategoryUrl = "/category";

// get all products category
export const getProductsCategoryRequest = (values) =>
  client.get(`${productsCategoryUrl}?${
    values.is_parent ? "is_parent=1&" : ""
  }skip=${values.skip ?? 0}&limit=${values.limit ?? 10}
  ${values.search ? "&search=" + convertNum(values.search) : ""}`);

// get product category by id
export const getProductCategoryByIdRequest = (values) =>
  client.get(`${productsCategoryUrl}/${values.id}`);

// edit products category
export const editProductsCategoryRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  formData.append("title", values.title);
  values.image.isChanged && formData.append("image", values.image.url);
  return client.post(
    `/admin${productsCategoryUrl}/${values.id}?
    _method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};
// delete products category
export const deleteProductsCategoryRequest = (id) =>
  client.delete(`/admin${productsCategoryUrl}/${id}`);

// add product category
export const addProductsCategoryRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  formData.append("title", values.title);
  values.image.isChanged && formData.append("image", values.image.url);

  return client.post(`/admin${productsCategoryUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

/////// products subcategory ///////

// delete products subcategory
export const deleteProductsSubCategoryByIdRequest = (id) =>
  client.delete(`admin${productsCategoryUrl}/${id}`);

// add product subcategory
export const addProductsSubCategoryRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  formData.append("title", values.title);
  formData.append("parent_id", values.parent_id);
  values.image.isChanged && formData.append("image", values.image.url);
  return client.post(`/admin${productsCategoryUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
